export const DateFormatter = (dateStr: string, withHour = false, newDate = false): string => {
  const date = newDate ? new Date() : new Date(dateStr);

  if (!dateStr && !newDate) {
    return 'None';
  }
  if (date.toString() === 'Invalid Date') {
    return 'None';
  }

  if (withHour) {
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
